/**
 * @file
 * A JavaScript file containing the magnific popup trigger functionality
 */

(function (Drupal, $) {
  Drupal.behaviors.popup = {
    attach: function (context) {
      'use strict';

      $('.popup-trigger', context).once('popup-enabled').addClass("popup-enabled").each(function () {
        $(function () {
          $('.popup-trigger').magnificPopup({
            type: 'inline',
            preloader: false,
          });
        });
      });      

      $('.popup-link', context).once('popup-link-enabled').addClass("popup-link-enabled").each(function () {
        $(this).magnificPopup({
          type: 'image',
          preloader: false,
        });
      });

      $('.popup-gallery', context).once('popup-gallery-enabled').addClass("popup-gallery-enabled").each(function () {
        $(this).magnificPopup({
          delegate: 'a',
          type: 'image',
          preloader: false,
          gallery:{ enabled: true },
        });
      });      

    }
  }
})(Drupal, jQuery);
